// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2pkOh","list":"styles_list__1ipb1"};